import React from "react";
import EpisodeInfoPage from "../episodes/EpisodeInfoPage";
import { getEpisodeInfo } from "../../../store/actions/uploadMediaAction";

const ViewEpisode = () => (
  <EpisodeInfoPage
    idParam="episodeInfo_id"
    storeKey="generalContentObjEpisodeInfo"
    setEpisodeInfo={getEpisodeInfo}
    pagePath={(id) => `/dashboard/episode-info/${id}`}
    commentsType="show"
    noMediaText="Episodes have not been uploaded yet!"
  />
);

export default React.memo(ViewEpisode);
